import CardVal from 'card-validator';

import { instanceAxios } from '../InstanceAxios';
import { mapCardBrandToIugu } from '../modules/pagamento/utils/mapCardBrandToIugu';

function brandFromCardNumber(number) {
  if (!number) {
    return undefined;
  }
  const { card } = CardVal.number(String(number));
  return mapCardBrandToIugu(card?.type);
}

class Payment {
  async validate_refer_code({ token, referCode, value, setReferCodeObj }) {
    const axios = await instanceAxios(token);
    axios
      .post('/validarCodigo', {
        codigo: referCode,
        valor: value,
      })
      .then((res) => {
        setReferCodeObj(res.data);
      })
      .catch((err) => {
        setReferCodeObj(null);
      });
  }

  async signature_payment({
    token,
    id,
    number,
    codigoCartao,
    first_name,
    last_name,
    mes,
    ano,
    assinatura,
    email,
    cupomObj,
    referCodeObj,
    id_payment,
    usuario,
  }) {
    const instance = await instanceAxios(token, id);
    return await instance.post('/criarAssinatura', {
      number,
      verification_value: codigoCartao,
      first_name,
      last_name,
      month: mes,
      year: ano,
      brand: brandFromCardNumber(number),
      plan_identifier: assinatura.identificador_iugu,
      email,
      payable_with: 'credit card',
      id_payment,
      cupom: cupomObj,
      codigo: referCodeObj
        ? {
            valor: referCodeObj.valor.toFixed(2).toString().replace('.', ''),
            codigo: referCodeObj.codigo,
          }
        : null,
      usuario,
    });
  }

  async service_signature_payment({
    token,
    id,
    assinatura,
    referCodeObj,
    number,
    codigoCartao,
    first_name,
    last_name,
    month,
    year,
    email,
    cpf_cnpj,
    address,
    username,
    servico,
    cupomObj,
    setLoading,
    signaturePlan,
    id_payment,
    usuario,
    portal,
  }) {
    const instance = instanceAxios(token, id);
    return await instance
      .post('/criarAssinatura', {
        number,
        verification_value: codigoCartao,
        first_name,
        last_name,
        month,
        year,
        brand: brandFromCardNumber(number),
        plan_identifier: assinatura.identificador_iugu,
        method: 'credit_card',
        email,
        cpf_cnpj,
        street: address ? address.logradouro : '',
        address_number: address ? address.numero : '',
        name: username,
        zip_code: address ? address.cep : '',
        complement: address ? address.complemento : '',
        servico,
        id_usuario: id,
        id_servico: servico ? servico.id : null,
        cupom: cupomObj,
        codigo: referCodeObj
          ? {
              valor: referCodeObj.valor.toFixed(2).toString().replace('.', ''),
              codigo: referCodeObj.codigo,
            }
          : null,
        id_payment,
        usuario,
        portal,
      })
      .then((res) => {
        console.log('Payment', servico);

        const resp = { status: 'success', message: res.data.message };
        return resp;
      });
  }

  async signature_payment_pix_automatic({
    token,
    id,
    assinatura,
    email,
    cpf_cnpj,
    username,
    usuario,
    portal,
  }) {
    const instance = await instanceAxios(token, id);
    return instance.post('/criarAssinaturaPixAutomatica', {
      plan_identifier: assinatura.identificador_iugu,
      email,
      cpf_cnpj,
      name: username,
      usuario,
      portal,
    });
  }

  async signature_payment_pix({
    token,
    id,
    assinatura,
    email,
    cpf_cnpj,
    username,
    usuario,
    portal,
    servico,
  }) {
    const instance = await instanceAxios(token, id);
    return instance.post('/criarAssinaturaComPix', {
      plan_identifier: assinatura.identificador_iugu,
      email,
      cpf_cnpj,
      name: username,
      usuario,
      portal,
      servico: servico || null,
      id_servico: servico ? servico.id : null,
    });
  }

  async verify_pix_signature({ token, id, faturaId }) {
    const instance = await instanceAxios(token, id);
    return instance.get(`/verificarPixAssinaturaConfirmada/${faturaId}`);
  }

  async save_payment({
    token,
    id,
    number,
    verification_value,
    first_name,
    last_name,
    month,
    year,
    setLoading,
  }) {
    setLoading(true);
    const instance = await instanceAxios(token, id);
    await instance
      .post('/cartaoCredito', {
        id_usuario: id,
        number,
        verification_value,
        first_name,
        last_name,
        month,
        year,
      })
      .then(async (res) => {
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }

  async get_payment({
    token,
    id,
    setLoading,
    setDefaultPayment,
    // modalizeDefaultPayment,
  }) {
    setLoading(true);
    const instance = await instanceAxios(token);
    await instance
      .get(`/cartaoCredito?id=${id}`)
      .then(async (res) => {
        setDefaultPayment(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setDefaultPayment(null);
        setLoading(false);
      });
  }
}

export default new Payment();
